// Traducciones para página principal - Español
export const homeEs = {
  // Sección de bienvenida/hero
  welcome: {
    title: 'Encuentra tu próximo vehículo en',
    description:
      'Describe el vehículo de tus sueños y deja que nuestra IA encuentre las mejores opciones para ti.',
    searchButton: 'Buscar vehículos',
    aiSearchPlaceholder: 'Busca por marca, modelo, tipo, color, condición...',
    clearSearch: 'Limpiar',
    search: 'Buscar',
    voiceSearch: 'Búsqueda por voz',
  },

  // Sección "Por qué elegirnos"
  whyUs: {
    title: '¿Por qué elegirnos?',
    subtitle: 'Descubre por qué nuestros clientes confían en nosotros',
    defaultFeatures: {
      quality: {
        title: 'Vehículos de Calidad',
        description:
          'Todos nuestros vehículos pasan por una rigurosa inspección de calidad.',
      },
      experience: {
        title: 'Años de Experiencia',
        description:
          'Contamos con más de 10 años de experiencia en el mercado automotriz.',
      },
      service: {
        title: 'Atención Personalizada',
        description:
          'Te acompañamos en todo el proceso de compra de tu vehículo.',
      },
    },
  },

  // Sección de contacto CTA
  contactCTA: {
    title: '¿Listo para encontrar tu próximo vehículo?',
    subtitle: 'Contáctanos hoy mismo.',
    button: 'Contactar',
    phone: 'Llamar ahora',
    whatsapp: 'WhatsApp',
  },

  // Sección "Cómo llegar"
  howToArrive: {
    title: '¿Cómo llegar?',
    subtitle: 'Encuéntranos en la siguiente dirección:',
    button: 'Cómo llegar en Google Maps',
    address: 'Dirección',
    hours: 'Horarios de atención',
    phone: 'Teléfono',
    email: 'Email',
    ofTotal: 'de',
    showMap: 'Ver mapa',
    mapUnavailable: 'No pudimos cargar el mapa.',
  },

  // Sección de vehículos destacados
  featuredVehicles: {
    title: 'Vehículos Destacados',
    subtitle: 'Descubre nuestra selección de vehículos premium',
    viewAll: 'Ver todos los vehículos',
    noVehicles: 'No hay vehículos destacados disponibles',
  },
};



